import React from "react";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import CustomModal from "../../../UI Component/Modal/CustomModal";
import { makeStyles } from "@material-ui/styles";
import Filter from "../../../../assets/Filter.svg";
import Sort from "../../../../assets/sort-icon.png";
import "./accountHeader.scss";
import { USER_ROLE, USER_TYPE } from "../../../../Util/constants";
import SearchBarWithIcon from "../../Modules/SearchBarWithIcon";

const AccountHeader = (props) => {
  const {
    inputText,
    doctorAccount,
    filterApplied,
    showFilter,
    showSort,
    accountFilters,
    toggleSort,
    toggleFilter,
    sortApplied,
    handleApplySort,
    handleResetAll,
    handleApplyFilter,
    activeButton,
    handlePendingAppointmentLogs,
    toggleSpecilisation,
    accountsClickHandler,
    onDocResourcesClick,
    doctorStatusData,
    allDocsResourcesList,
    totalCount,
  } = props;

  const useStyles = makeStyles(() => ({
    activeButton: {
      background: "#17bae0",
      color: "#fff",
    },
  }));

  const classes = useStyles();
  const buttons = ["All", "In", "Out", "Leave"];
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  // Lifecycle methods ==>
  // Helper methods ==>
  // Actions  ==>

  const clickedButtonHandler = (name) => {
    accountsClickHandler(name);
  };

  // Create UI ==>
  const displayOnlineAppointmentLogs = () => {
    return (
      <>
        {(doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          userType === USER_TYPE.STAFF ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_CONSULTANT) && (
          <div
            className="account-header-online-appointments-log"
            onClick={handlePendingAppointmentLogs}
          >
            <i className="fa fa-calendar account-header-online-appointments-log-icon"></i>
            &nbsp;&nbsp;&nbsp;Online Appointment Logs
          </div>
        )}
      </>
    );
  };

  const filterIcon = () => {
    return (
      <button onClick={() => toggleFilter()} className="filter-icon">
        {filterApplied ? <div className="filter-red-dot"></div> : null}
        <img
          src={Filter}
          alt="Filter"
          style={{ marginRight: "5px", cursor: "pointer" }}
        />
      </button>
    );
  };

  const sortIcon = () => {
    return (
      <button onClick={() => toggleSort()} className="filter-icon">
        {sortApplied ? <div className="filter-red-dot"></div> : null}
        <img
          src={Sort}
          alt="Sort"
          style={{ marginRight: "5px", cursor: "pointer", height: "21px" }}
        />
      </button>
    );
  };

  const accountsAndFilter = () => {
    return (
      <div className="right-content-header pr-3">
        <div style={{ display: "flex", flex: "1" }}>
          ACCOUNTS
          {+totalCount < 10 ? `(0${totalCount})` : `(${totalCount})`}
        </div>
      </div>
    );
  };
  const getAllDocsResources = () => {
    const option = (obj) => {
      return (
        <div
          className={
            window.innerWidth < 1024
              ? "appointment-filter-body-right-div"
              : "appointment-dropdown-item d-flex text-label"
          }
          onClick={() => onDocResourcesClick(obj)}
        >
          <i
            className={
              window.innerWidth < 1024 ? "fa fa-check mr-1" : "fa fa-check mr-3"
            }
            style={{
              color: obj.selected ? "#17bae0" : "rgba(0, 0, 0, 0.3)",
            }}
            aria-hidden="true"
          ></i>
          {obj.title}
        </div>
      );
    };
    return allDocsResourcesList?.map((obj) => {
      return obj.title === "all"
        ? option(obj)
        : accountFilters
        ? (doctorRole === USER_ROLE.DOCTOR_ADMIN ||
            userType === USER_TYPE.STAFF) &&
          option(obj)
        : null;
    });
  };

  const searchBar = () => {
    return (
      <div
        className="pt-3 pr-3 mb-3"
        style={{ display: "flex", position: "relative" }}
      >
        <div style={{ width: "95%", marginRight: "10px" }}>
          <SearchBarWithIcon
            search_string={inputText}
            inputCallBack={(value) => props.onChange(value)}
            placeholder="Search by Account name"
            isClearable={true}
          />
        </div>
        <div style={{ display: "flex" }}>
          {doctorAccount ? sortIcon() : null}
          {doctorAccount ? filterIcon() : null}
        </div>
        {showSort && window.innerWidth > 1024 ? (
          <div
            className="doctor-filter"
            // style={{ transform: props.transformStyle }}
          >
            <div className="dropdown">
              {doctorStatus(
                "appointment-dropdown-item d-flex text-label",
                "fa fa-check mr-3"
              )}
            </div>
            {/* {filterFooter()} */}
          </div>
        ) : null}

        {showSort && window.innerWidth < 1024
          ? filterDropdownMobileView()
          : null}
        {showFilter && window.innerWidth > 1024 ? (
          <div
            className="specialization-filter"
            // style={{ transform: props.transformStyle }}
          >
            <div className="dropdown">
              {getAllDocsResources()}
              <div>
                {FilterDropdown(
                  "appointment-dropdown-item d-flex text-label",
                  "fa fa-check mr-3"
                )}
              </div>
            </div>
            {filterFooter()}
          </div>
        ) : null}

        {showFilter && window.innerWidth < 1024
          ? filterDropdownMobileView()
          : null}
      </div>
    );
  };

  const renderStatus = () => {
    return (
      <div className={"status-wrapper mr-3"}>
        {buttons.map((name, ind) => (
          <button
            key={ind}
            name={name}
            className={`status-button  ${
              activeButton === name ? `${classes.activeButton}` : ""
            }`}
            onClick={() => clickedButtonHandler(name)}
          >
            {name}
          </button>
        ))}
      </div>
    );
  };

  const FilterDropdown = (divClass, iconclass) => {
    return accountFilters?.map((item, index) => (
      <div
        onClick={() => toggleSpecilisation(item)}
        className={divClass}
        key={index}
      >
        <i
          className={iconclass}
          style={{
            color: item.selected ? "#17bae0" : "rgba(0, 0, 0, 0.3)",
          }}
          aria-hidden="true"
        ></i>
        {item.specialisation_name}
      </div>
    ));
  };

  const doctorStatus = (divClass, iconclass) => {
    return doctorStatusData.map((item, index) => (
      <div
        onClick={() => handleApplySort(item, doctorAccount, false)}
        className={divClass}
        key={index}
      >
        <i
          className={iconclass}
          style={{
            color: item?.selected ? "#17bae0" : "white",
          }}
          aria-hidden="true"
        ></i>

        {item.name}
      </div>
    ));
  };

  const filterDropdownMobileView = () => {
    return (
      <CustomModal
        show={showFilter && window.innerWidth < 1024 ? showFilter : false}
      >
        <div
          style={{
            display: "block",
            background: "#fff",
            width: "100%",
            position: "absolute",
            bottom: "0",
          }}
        >
          <div className="d-flex col-sm-12 d-lg-none appointment-filter-header-div">
            <div>Filter</div>
            <div className="ml-auto" onClick={() => toggleFilter()}>
              Close
              <i className="fa fa-close pl-1" aria-hidden="true"></i>
            </div>
          </div>

          <div className="appointment-filter-body-div d-flex">
            <div
              className={`appointment-filter-body-sidebar-div col-sm-6 p-0`}
              style={{ textTransform: "capitalize" }}
            >
              <div className="active">Specialisation</div>
            </div>

            <div className="col-sm-6" style={{ overflowY: "scroll" }}>
              {getAllDocsResources()}
              <div>
                {FilterDropdown(
                  "appointment-filter-body-right-div",
                  "fa fa-check mr-1"
                )}
              </div>
            </div>
          </div>

          {filterFooter()}
        </div>
      </CustomModal>
    );
  };

  const filterFooter = () => {
    return (
      <div className="d-flex col-sm-12 filter-button p-2">
        <a
          className="ml-auto appointment-date-range-reset"
          style={{
            textTransform: "capitalize",
            background: "transparent",
            cursor: "pointer",
          }}
          onClick={() => handleResetAll()}
        >
          Reset All
        </a>
        <button
          className="ml-2 appointment-date-range-apply"
          onClick={() => handleApplyFilter()}
          style={{ width: "60px", height: "26px" }}
        >
          Apply
        </button>
      </div>
    );
  };

  // render UI <==

  return (
    <div className="dashboard-accounts-header">
      {displayOnlineAppointmentLogs()}
      {searchBar()}
      {accountsAndFilter()}
      {renderStatus()}
    </div>
  );
};

export default AccountHeader;
